import React from 'react';

export default function SignupLegalNotice() {
  const linkClassName = 'text-[var(--color-text-primary)] underline underline-offset-4 hover:text-[var(--color-accent)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4';

  return (
    <p className="text-sm leading-6 text-[var(--color-text-secondary)]">
      By creating an account, you agree to our{' '}
      <a href="/terms-of-use" target="_blank" rel="noopener noreferrer" className={linkClassName}>
        Terms of Use
      </a>{' '}
      and acknowledge our{' '}
      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className={linkClassName}>
        Privacy Policy
      </a>
      .
    </p>
  );
}
